"use client";

import Link from "next/link";
import LazyImage from "src/lib/components/salify-next-layout/default/components/LazyImage";
import {
  ContentWrapper,
  FeaturedImgBox,
  StyledCard,
} from "src/lib/components/product-item/vertical/styles";
import {
  H2,
  Paragraph,
  Span,
} from "src/lib/components/salify-next-layout/default/components/Typography";
import Box from "@mui/material/Box";
import { FlexBox } from "src/lib/components/salify-next-layout/default/components/flex-box";
import { formatMoney, toAssetImages } from "src/lib/utils";
import Rating from "@mui/material/Rating";
import ProductViewDialog from "src/lib/components/salify-next-layout/default/components/products-view/product-view-dialog";
import useProduct from "src/lib/components/salify-next-layout/default/components/product-cards/use-product";
import HoverActions from "src/lib/components/product-item/default/hover-action";
import DiscountChip from "src/lib/components/salify-next-layout/default/components/product-cards/discount-chip";

// ============================================================
const ProductItemVertical = (props: any) => {
  const { isFavorite, openModal, toggleDialog, toggleFavorite, handleCartAmountChange } =
    useProduct(props.slugName);
  const featuredBgImg = props.featuredOption || "misc/featured-background-opt2.png";
  const featuredImgBoxParams = { bgImg: props.isFeature ? featuredBgImg : undefined };
  return (
    <StyledCard sx={props.sx}>
      <FeaturedImgBox id="imgBox" {...featuredImgBoxParams}>
        {props.saleOffPercent > 0 && <DiscountChip discount={props.saleOffPercent} />}
        <Link href={`/product/${props.slugName}`}>
          <LazyImage
            alt={props.name}
            width={700}
            height={700}
            src={toAssetImages(props.imageUrl)}
            style={{
              objectFit: "contain",
            }}
          />
        </Link>

        <HoverActions
          isFavorite={isFavorite}
          toggleView={toggleDialog}
          toggleFavorite={toggleFavorite}
          handleAddToCart={() =>
            handleCartAmountChange({
              product: props,
              quantity: 1,
            })
          }
        />
      </FeaturedImgBox>

      <ProductViewDialog openDialog={openModal} handleCloseDialog={toggleDialog} product={props} />

      <ContentWrapper>
        <Link href={`/product/${props.slugName}`} className="title">
          <H2 mb={1} title={props.name} fontSize={14} fontWeight={600} color="text.secondary">
            {props.name}
          </H2>
        </Link>

        <FlexBox gap={1} alignItems="center">
          <Rating size="small" value={Math.round(props.rating) || 5} color="warn" readOnly />
          <Span>{props.rating || 5}</Span>
        </FlexBox>

        <FlexBox alignItems="center" gap={1} mt={0.5}>
          <Paragraph fontWeight={600} color={props.highlightPrice ? "warning.900" : "inherit"}>
            {/*TODO: highlightPrice?*/}
            {formatMoney(props.salePrice)}
          </Paragraph>

          {props.saleOffPercent ? (
            <Box component="del" fontWeight={600} color="grey.600">
              {formatMoney(props.originalSalePrice)}
            </Box>
          ) : null}
        </FlexBox>
      </ContentWrapper>
    </StyledCard>
  );
};

export default ProductItemVertical;
